import { GameServices } from "game/GameServices";
import { View } from "@westpierstudio/luma/mvc";
import { Orientation } from "@westpierstudio/luma/layout";
import { Sprite } from "pixi.js";
import { minimumHeightSpecSelector, orientationSpecSelector } from "utils/Responsive";
import { Spine } from "pixi-spine";

export class PortraitLogo extends View {
    private spec: Record<string, any>;
    private mainLogo!: Sprite;
    private mainLogoRays!: Spine;

    constructor(protected override readonly services: GameServices) {
        super(services);

        const {layout, factory, resources} = this.services;
        this.spec = resources.getSpec(`logo`);

        this.mainLogoRays = factory.createSpine(this.spec.main_godrays, this);
        this.mainLogoRays.state.timeScale = 0.5;
        this.mainLogoRays.state.setAnimation(0, `idle-spin`, true);

        this.mainLogo = factory.createSprite(this.spec.main_logo, this);

        this.resize(layout.orientation);
    }

    resize(orientation: Orientation): void {

        if (orientation === `landscape`) {
            this.disable();

            return;
        }

        this.enable();

        let spec = orientationSpecSelector(this.services, this.spec, minimumHeightSpecSelector(this.services, this.spec.portrait.logo));
        this.services.factory.applySpec(this.mainLogo, spec);

        spec = orientationSpecSelector(this.services, this.spec, minimumHeightSpecSelector(this.services, this.spec.portrait.rays));
        this.services.factory.applySpec(this.mainLogoRays, spec);
    }

    private enable(): void {
        this.mainLogoRays.visible = true;
        this.mainLogo.visible = true;
    }

    private disable(): void {
        this.mainLogoRays.visible = false;
        this.mainLogo.visible = false;
    }
}